/**
 * P云广告SDK加载模块
 * 动态加载SDK并提供初始化方法
 */

import { pyunSdkUrl } from '../../config/pyunConfig'
import { logger } from './pyunLogger'

let sdkLoaded = false
let sdkLoading = false
let loadPromise = null

/**
 * 动态加载P云SDK
 * @returns {Promise<boolean>} 是否加载成功
 */
export function loadPyunSdk () {
  logger.info('[PyunSDK] ==================== 加载SDK ====================')
  logger.info('[PyunSDK] SDK地址:', pyunSdkUrl)
  logger.info('[PyunSDK] 当前状态:', { sdkLoaded, sdkLoading, hasPyun: !!window.pyun })

  // 已加载
  if (sdkLoaded && window.pyun) {
    logger.info('[PyunSDK] ✅ SDK已加载，直接返回')
    return Promise.resolve(true)
  }

  // 正在加载中，返回同一个Promise
  if (sdkLoading && loadPromise) {
    logger.info('[PyunSDK] ⏳ SDK正在加载中，等待...')
    return loadPromise
  }

  sdkLoading = true
  logger.info('[PyunSDK] 开始动态加载SDK...')

  loadPromise = new Promise((resolve, reject) => {
    // 检查是否已存在
    if (window.pyun) {
      logger.info('[PyunSDK] ✅ window.pyun 已存在')
      sdkLoaded = true
      sdkLoading = false
      resolve(true)
      return
    }

    // 创建 script 标签
    const script = document.createElement('script')
    script.src = pyunSdkUrl
    script.async = true

    script.onload = () => {
      logger.info('[PyunSDK] ✅ script.onload 触发')
      logger.info('[PyunSDK] window.pyun:', window.pyun ? '存在' : '不存在')
      logger.info('[PyunSDK] pyun.advertingPull:', window.pyun && typeof window.pyun.advertingPull === 'function' ? '存在' : '不存在')
      logger.info('[PyunSDK] pyun.advertingIntercept:', window.pyun && typeof window.pyun.advertingIntercept === 'function' ? '存在' : '不存在')
      sdkLoaded = true
      sdkLoading = false
      resolve(true)
    }

    script.onerror = (err) => {
      logger.error('[PyunSDK] ❌ script.onerror 触发', err)
      logger.error('[PyunSDK] 加载地址:', pyunSdkUrl)
      sdkLoading = false
      reject(err)
    }

    logger.info('[PyunSDK] 添加 script 标签到 head...')
    document.head.appendChild(script)
  })

  return loadPromise
}

/**
 * 检查SDK是否已加载
 * @returns {boolean}
 */
export function isPyunSdkLoaded () {
  const loaded = sdkLoaded && !!window.pyun
  logger.info('[PyunSDK] 检查SDK加载状态:', { sdkLoaded, hasPyun: !!window.pyun, result: loaded })
  return loaded
}

/**
 * 获取pyun对象
 * @returns {Object|null}
 */
export function getPyunInstance () {
  const pyun = window.pyun || null
  logger.info('[PyunSDK] 获取pyun实例:', pyun ? '成功' : '失败(null)')
  return pyun
}
